module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "fluid": "fluid",
      "grid-list-md": "grid-list-md"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "wrap"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "xs12",
      "md4": "md4"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "wrap"
    }
  }, _vm._l((_vm.openTickets), function(t, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs6": "xs6"
      }
    }, [_c('v-card', {
      staticClass: "elevation-1 text-xs-center",
      attrs: {
        "height": "100%"
      }
    }, [_c('v-card-text', [_c('div', {
      staticClass: "d-flex ai-center jc-center"
    }, [_c('div', {
      staticClass: "display-1 mb-2 font-weight-700"
    }, [_vm._v(_vm._s(_vm.abiertos[t.key]))])]), _c('span', {
      staticClass: "font-size-13"
    }, [_vm._v(_vm._s(t.label))])])], 1)], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15fde3bb","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_welcome_customer.vue
// module id = 479
// module chunks = 1